/**
 * Required to prevent iOS (NSCacheUrl) from caching request
 * content & headers, even for POST requests!
 */
const requestHeaderCacheControlNoStorage = {
    'Cache-Control': 'no-cache, no-store, max-age=0',
};
export { requestHeaderCacheControlNoStorage };
